import Fade from "react-reveal/Fade";

const Bigcard = ({ icon, color, title, bodyText, border }) => {
  return (
    <Fade left>
      <div className={`big-card ${border}`} style={{ background: color }}>
        <div className="big-card__top">
          <div className="big-card__top__icon-wrapper">
            <img src={icon} alt="" />
          </div>
        </div>
        <div className="big-card__title">
          <h3>{title}</h3>
        </div>
        <div className="big-card__text">
          <p>{bodyText}</p>
        </div>
      </div>
    </Fade>
  );
};

export default Bigcard;
